import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { setBaseUrl } from "@tcg-web/api-client-react";
import { AuthProvider } from "./lib/auth";
import { AppProvider } from "./context/AppContext";
import { routeTree } from "./routeTree.gen";
import { initKioskMode } from "./lib/kioskMode";
import "./index.css";

// Capture ?kiosk=1 from the ENTRY url before the router mounts — TanStack routes
// declare validateSearch and would strip the unrecognized param first. Persists
// to sessionStorage so it survives in-app navigation (see lib/kioskMode).
initKioskMode();

// Generated React-Query hooks share a custom fetcher; point it at our
// same-origin API. The session rides an HttpOnly cookie the browser attaches
// automatically (TNK-54), so no bearer-token getter is wired on web.
setBaseUrl("");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppProvider>
          <RouterProvider router={router} />
        </AppProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
